import React, { useEffect } from 'react';
import { useCompany } from './CompanyContext';
import { useUser } from './UserContext';
import CompanySelector from './CompanySelector';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';

interface CompanyGuardProps {
  children: React.ReactNode;
}

const CompanyGuard: React.FC<CompanyGuardProps> = ({ children }) => {
  const { selectedCompany, setSelectedCompany, companies, loading } = useCompany();
  const { isAdmin } = useUser();
console.log(companies)
console.log(selectedCompany)
  useEffect(() => {
    if (companies.length === 1) {
      setSelectedCompany(companies[0]);
    }
  }, [companies, setSelectedCompany]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading companies...</p>
        </div>
      </div>
    );
  }

  // Admin users can access the dashboard without selecting a company
  // Non-admin users must select a company
  if (!selectedCompany && !isAdmin) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
          <div className="text-center mb-8">
            <BuildingOfficeIcon className="mx-auto h-16 w-16 text-primary-600 mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Select a Company</h2>
            <p className="text-gray-600">
              Please select a company to access the dashboard and manage your business operations.
            </p>
          </div>
          
          <div className="space-y-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Choose Company
            </label>
            <CompanySelector />
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default CompanyGuard;
